import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@ff-os/shared-react/components/dropdown/Dropdown';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { VariantOption } from '../../../../VariantOption';
import styles from './VariantDropdown.module.scss';

const OptionText = ({ label }: { label: string }) => (
    <span className={styles.optionText}>
        {label}
    </span>
);

export const BorderDropdown = ({
    label, value, onChange, options, className
}: Props) => {

    const { t } = useTranslation();

    const selected = options.find(o => o.value === value)!;

    return (
    <>
        <Dropdown
            label={label}
            renderPreview={() => <OptionText label={t(selected?.name?.key)} />}
            className={className}
            fieldClassName={styles.field}>
            {options.map(o => (
                <ListItem key={o.value}
                    onClick={() => onChange(o.value)}
                    active={o.value === value}>
                    <OptionText label={t(o.name.key)} />
                </ListItem>
            ))}
        </Dropdown>
    </>
    );
};

type Props = {
    label: string;
    value: string;
    className?: string;
    onChange: (value: string) => void;
    options: VariantOption[];
};